module.exports = __webpack_public_path__ + "images/hipages.b2df3206d83b5c47dcb08849ea36f291.jpg";